<div class="upgrade-modal-overlay">
  <div class="upgrade-modal-wrapper">
    <div class="upgrade-modal-content">
      <button class="upgrade-modal-close" (click)="modalRef.hide()">
        <i class="fa-solid fa-xmark"></i>
      </button>
        <div class="upgrade-modal-inner">
            <!-- left panel -->
             <ng-container [ngSwitch]="upgradeType">
                    <!-- Pro -->
                    <div  *ngSwitchCase="'pro'" class="upgrade-modal-body">
                        <h2 class="upgrade-modal-title">
                        <i class="fa-solid fa-crown text-purple"></i>
                        Upgrade to Pro
                        </h2>

                        <p class="upgrade-modal-subtitle">
                        Unlock everything you need to customize and automate your workspace
                        </p>
                        <p class="upgrade-modal-subtitle">
                            Here’s what you get with Pro
                        </p>

                        <ul class="upgrade-modal-features">
                        <li><i class="fa-solid fa-check"></i> Access asset logs, analytics, and full customization.</li>
                        <li><i class="fa-solid fa-check"></i> Template-based creation, checklist builder, and workflows.</li>
                        <li><i class="fa-solid fa-check"></i> Digitized inventory, maintenance scheduling, and asset requests.</li>
                        <li><i class="fa-solid fa-check"></i> Custom dropdowns, list views, labels, and forms.</li>
                        <li><i class="fa-solid fa-check"></i> API access and support for data connectors</li>
                        </ul>

                        <button class="btn-upgrade" (click)="goToBilling()">
                        <i class="fa-solid fa-crown"></i>
                        Upgrade Now
                        </button>
                    </div>
                    <!-- Enterprise -->
                    <div *ngSwitchCase="'enterprise'" class="upgrade-modal-body">
                        <h2 class="upgrade-modal-title">
                        <i class="fa-solid fa-crown text-bronze"></i>
                        Upgrade to Enterprise
                        </h2>

                        <p class="upgrade-modal-subtitle">
                        Get access to powerful features built for large teams and complex operations
                        </p>
                        <p class="upgrade-modal-subtitle">
                            Here’s what you get with Enterprise
                        </p>

                        <ul class="upgrade-modal-features">
                        <li><i class="fa-solid fa-check"></i> Work order surveys and SLAs</li>
                        <li><i class="fa-solid fa-check"></i> Custom notifications and configurable dashboard</li>
                        <li><i class="fa-solid fa-check"></i> Test workflows, configurations, and integrations in a sandbox environment.</li>
                        <li><i class="fa-solid fa-check"></i> Everything in the Pro plan.</li>
                        </ul>

                        <button class="btn-upgrade" (click)="goToBilling()">
                        <i class="fa-solid fa-crown"></i>
                        Upgrade Now
                        </button>
                    </div>
                
             </ng-container>

            <!-- right panel -->
            <div class="upgrade-modal-visual">
                 <img *ngIf="upgradeType === 'pro'" src="../../../../assets/svg/modal/upgrade-pro.svg" alt="Upgrade Pro Image">
                <img *ngIf="upgradeType === 'enterprise'" src="../../../../assets/svg/modal/upgrade-enterprise.svg" alt="Upgrade Enterprise Image">
            </div>
        </div>
    </div>
  </div>
</div>
